//
// GENERATED FILE - DO NOT CHANGE
// Generated by `php artisan rphq-js:dump-enums`
// See app/Console/Commands/Build/JavascriptDumpEnumsCommand.php
//

export enum ContractReadyForPurchase {
    IS_NOT_DRAFT = 'IS_NOT_DRAFT',
    IS_CUSTOM = 'IS_CUSTOM',
    COURSE_CANCELLED = 'COURSE_CANCELLED',
    ENROLLMENT_RANGE_NOT_DEFINED_BY_PLAN = 'ENROLLMENT_RANGE_NOT_DEFINED_BY_PLAN',
    ENROLLMENT_COUNT_LESS_THAN_PLAN_MINIMUM = 'ENROLLMENT_COUNT_LESS_THAN_PLAN_MINIMUM',
    ENROLLMENT_COUNT_GREATER_THAN_PLAN_MAXIMUM = 'ENROLLMENT_COUNT_GREATER_THAN_PLAN_MAXIMUM',
    MISSING_REQUIRED_PLAN_ENROLLMENT = 'MISSING_REQUIRED_PLAN_ENROLLMENT',
    HAS_UNFILLED_ENROLLMENTS = 'HAS_UNFILLED_ENROLLMENTS',
    ENROLLMENT_OUTSIDE_AGE_RANGE = 'ENROLLMENT_OUTSIDE_AGE_RANGE',
    START_DATE_SESSION_JOIN_MISMATCH = 'START_DATE_SESSION_JOIN_MISMATCH',
    END_DATE_SESSION_JOIN_MISMATCH = 'END_DATE_SESSION_JOIN_MISMATCH',
    START_DATE_BEFORE_BOOKING_DATE = 'START_DATE_BEFORE_BOOKING_DATE',
    START_DATE_AFTER_BOOKING_DATE_PLUS_DAYS_AHEAD = 'START_DATE_AFTER_BOOKING_DATE_PLUS_DAYS_AHEAD',
    FIXED_DURATION_END_DATE_MISMATCH = 'FIXED_DURATION_END_DATE_MISMATCH',
    MISSING_CONTRACT_QUESTION_PROPERTY = 'MISSING_CONTRACT_QUESTION_PROPERTY',
    REQUIRED_PLAN_QUESTION_UNANSWERED = 'REQUIRED_PLAN_QUESTION_UNANSWERED',
    MISSING_ENROLLMENT_QUESTION_PROPERTY = 'MISSING_ENROLLMENT_QUESTION_PROPERTY',
    AUTO_APPLY_PROMOTIONS_OUT_OF_DATE = 'AUTO_APPLY_PROMOTIONS_OUT_OF_DATE',
    INCOMPLETE_DOCUMENT = 'INCOMPLETE_DOCUMENT',
    VALID = 'VALID'
}
export function friendlyEnumContractReadyForPurchase(value: ContractReadyForPurchase): string {
	switch(value) {
		case "IS_NOT_DRAFT":
			return "Contract is not a draft contract."
		case "IS_CUSTOM":
			return "Contract is a custom contract (has no plan)."
		case "COURSE_CANCELLED":
			return "Course has been cancelled. Please go back and choose another course."
		case "ENROLLMENT_RANGE_NOT_DEFINED_BY_PLAN":
			return "Contract contains enrollment range not defined by plan."
		case "ENROLLMENT_COUNT_LESS_THAN_PLAN_MINIMUM":
			return "Contract enrollment count is less than plan minimum."
		case "ENROLLMENT_COUNT_GREATER_THAN_PLAN_MAXIMUM":
			return "Contract enrollment count is greater than plan maximum."
		case "MISSING_REQUIRED_PLAN_ENROLLMENT":
			return "Contract is missing required plan enrollment."
		case "HAS_UNFILLED_ENROLLMENTS":
			return "Contract has unfilled enrollments (no participant selected)."
		case "ENROLLMENT_OUTSIDE_AGE_RANGE":
			return "Contract has participant that does not meet their enrollment age range."
		case "START_DATE_SESSION_JOIN_MISMATCH":
			return "Contract start date does not match session join fixed start date."
		case "END_DATE_SESSION_JOIN_MISMATCH":
			return "Contract end date does not match session join fixed end date."
		case "START_DATE_BEFORE_BOOKING_DATE":
			return "Contract start date is before booking date."
		case "START_DATE_AFTER_BOOKING_DATE_PLUS_DAYS_AHEAD":
			return "Contract start date is after the maximum allowed future start date."
		case "FIXED_DURATION_END_DATE_MISMATCH":
			return "Contract end date does not match calculated fixed duration end date.."
		case "MISSING_CONTRACT_QUESTION_PROPERTY":
			return "Contract is missing property (response) for a contract question."
		case "REQUIRED_PLAN_QUESTION_UNANSWERED":
			return "Invalid response provided for a required plan question."
		case "MISSING_ENROLLMENT_QUESTION_PROPERTY":
			return "Contract is missing property (response) for an enrollment question."
		case "AUTO_APPLY_PROMOTIONS_OUT_OF_DATE":
			return "Contract pricing and promotions changed. Please review pricing and continue."
		case "INCOMPLETE_DOCUMENT":
			return "Required contract document is incomplete."
		case "VALID":
			return "Contract is valid for purchase."
		default:
			return value?.toString()
	}
}

export enum ProductCatalogVisibility {
    STANDARD = 'STANDARD',
    FULL_CATALOG_ONLY = 'FULL_CATALOG_ONLY'
}
export function friendlyEnumProductCatalogVisibility(value: ProductCatalogVisibility): string {
	switch(value) {
		case "STANDARD":
			return "Standard catalog"
		case "FULL_CATALOG_ONLY":
			return "Full catalog only"
		default:
			return value?.toString()
	}
}

export enum PlanBillingType {
    PREPAID = 0,
    RECURRING = 1
}
export function friendlyEnumPlanBillingType(value: PlanBillingType): string {
	switch(value) {
		case 0:
			return "Prepaid"
		case 1:
			return "Recurring"
		default:
			return value?.toString()
	}
}

export enum BillingInterval {
    WEEKLY = 0,
    FORTNIGHTLY = 1,
    MONTHLY = 2,
    QUARTERLY = 3,
    YEARLY = 4,
    DAILY = 5,
    ADVANCED = 6
}
export function friendlyEnumBillingInterval(value: BillingInterval): string {
	switch(value) {
		case 0:
			return "Weekly"
		case 1:
			return "Fortnightly"
		case 2:
			return "Monthly"
		case 3:
			return "Quarterly"
		case 4:
			return "Yearly"
		case 5:
			return "Daily"
		case 6:
			return "Advanced"
		default:
			return value?.toString()
	}
}

export enum ContractStatus {
    DRAFT = 0,
    ACTIVE = 1,
    FROZEN = 2,
    TERMINATED = 3
}
export function friendlyEnumContractStatus(value: ContractStatus): string {
	switch(value) {
		case 0:
			return "Draft"
		case 1:
			return "Active"
		case 2:
			return "Frozen"
		case 3:
			return "Terminated"
		default:
			return value?.toString()
	}
}

export enum BenefitFacilityType {
    HOME = 0,
    ALL = 1,
    SPECIFIC = 2
}
export function friendlyEnumBenefitFacilityType(value: BenefitFacilityType): string {
	switch(value) {
		case 0:
			return "Home Facility"
		case 1:
			return "All Facilities"
		case 2:
			return "Specific Facilities"
		default:
			return value?.toString()
	}
}

export enum BenefitType {
    UNLIMITED = 0,
    DYNAMIC_LEDGER = 1,
    FIXED_LEDGER = 2,
    ENROLLEE_DYNAMIC_LEDGER = 3,
    ENROLLEE_FIXED_LEDGER = 4
}
export function friendlyEnumBenefitType(value: BenefitType): string {
	switch(value) {
		case 0:
			return "Unlimited"
		case 1:
			return "Contract Period Grant"
		case 2:
			return "Contract Fixed Grant"
		case 3:
			return "Enrollee Period Grant"
		case 4:
			return "Enrollee Fixed Grant"
		default:
			return value?.toString()
	}
}

export enum BenefitPeriod {
    BILLING_CYCLE = 0,
    DAILY = 1,
    WEEKLY = 2,
    MONTHLY = 3,
    YEARLY = 4
}
export function friendlyEnumBenefitPeriod(value: BenefitPeriod): string {
	switch(value) {
		case 0:
			return "Billing Cycle"
		case 1:
			return "Daily"
		case 2:
			return "Weekly"
		case 3:
			return "Monthly"
		case 4:
			return "Yearly"
		default:
			return value?.toString()
	}
}

export enum PlanPricingType {
    SIMPLE = 0,
    STANDARD = 1,
    MATRIX = 2,
    CUSTOM = 3
}
export function friendlyEnumPlanPricingType(value: PlanPricingType): string {
	switch(value) {
		case 0:
			return "Simple"
		case 1:
			return "Standard"
		case 2:
			return "Matrix"
		case 3:
			return "Custom"
		default:
			return value?.toString()
	}
}

export enum BillingDaySource {
    FACILITY = 0,
    PLAN = 1,
    CONTRACT = 2
}
export function friendlyEnumBillingDaySource(value: BillingDaySource): string {
	switch(value) {
		case 0:
			return "Facility"
		case 1:
			return "Plan"
		case 2:
			return "Contract"
		default:
			return value?.toString()
	}
}

export enum BenefitExpiration {
    NONE = 0,
    FIXED = 1,
    RELATIVE = 2
}
export function friendlyEnumBenefitExpiration(value: BenefitExpiration): string {
	switch(value) {
		case 0:
			return "No expiration"
		case 1:
			return "Fixed Date"
		case 2:
			return "Relative"
		default:
			return value?.toString()
	}
}

export enum FreezeMode {
    NONE = 0,
    CONTRACT = 1,
    ENROLLEE = 2
}
export function friendlyEnumFreezeMode(value: FreezeMode): string {
	switch(value) {
		case 0:
			return "None"
		case 1:
			return "Contract"
		case 2:
			return "Enrollee"
		default:
			return value?.toString()
	}
}

export enum EnrollmentStatus {
    PENDING = 0,
    ACTIVE = 1,
    FROZEN = 2,
    TERMINATED = 3
}
export function friendlyEnumEnrollmentStatus(value: EnrollmentStatus): string {
	switch(value) {
		case 0:
			return "Pending"
		case 1:
			return "Active"
		case 2:
			return "Frozen"
		case 3:
			return "Terminated"
		default:
			return value?.toString()
	}
}

export enum SpokeType {
    PRICING = 0,
    COURSE_SCHEDULE = 1,
    BOOKING_PERIOD = 2,
    BOOKING_LIMITS = 3,
    CANCELLATION_TERMS = 4,
    FREEZE_TERMS = 5,
    DOCUMENT = 6,
    BENEFITS = 7,
    QUANTITY_CONSTRAINTS = 8,
    CUSTOMER_NOTIFICATIONS = 9,
    STAFF_NOTIFICATIONS = 10,
    PRESENTATION = 11,
    QUESTION_LAYOUT = 12,
    SESSION_JOIN = 13,
    GIFT_CARD_OPTIONS = 14
}
export function friendlyEnumSpokeType(value: SpokeType): string {
	switch(value) {
		case 0:
			return "Pricing"
		case 1:
			return "Course Schedule"
		case 2:
			return "Booking Period"
		case 3:
			return "Booking Limits"
		case 4:
			return "Cancellation Terms"
		case 5:
			return "Freeze Terms"
		case 6:
			return "Document"
		case 7:
			return "Benefits"
		case 8:
			return "QUANTITY_CONSTRAINTS"
		case 9:
			return "Customer Notifications"
		case 10:
			return "Staff Notifications"
		case 11:
			return "Online Presentation"
		case 12:
			return "Question Layout"
		case 13:
			return "Date Config"
		case 14:
			return "Gift Card Options"
		default:
			return value?.toString()
	}
}

export enum AssetScheduleFilterMode {
    FILTER_ENTIRE_COURSE = 1,
    FILTER_ONLY_SESSIONS = 2
}
export function friendlyEnumAssetScheduleFilterMode(value: AssetScheduleFilterMode): string {
	switch(value) {
		case 1:
			return "FILTER_ENTIRE_COURSE"
		case 2:
			return "FILTER_ONLY_SESSIONS"
		default:
			return value?.toString()
	}
}

export enum PlanType {
    MEMBERSHIP = 1,
    PROGRAM = 2,
    AGREEMENT = 3,
    PASS = 4,
    GIFTCARD = 5
}
export function friendlyEnumPlanType(value: PlanType): string {
	switch(value) {
		case 1:
			return "Membership"
		case 2:
			return "Program"
		case 3:
			return "Agreement"
		case 4:
			return "Pass"
		case 5:
			return "Gift Card"
		default:
			return value?.toString()
	}
}

export enum SessionJoinMode {
    FIRST_SESSION = 0,
    ANY_SESSION = 1,
    INSIDE_SESSION = 2
}
export function friendlyEnumSessionJoinMode(value: SessionJoinMode): string {
	switch(value) {
		case 0:
			return "First Session"
		case 1:
			return "Any Session"
		case 2:
			return "Inside Any Session"
		default:
			return value?.toString()
	}
}

export enum EventRelativeThresholdType {
    OFF = 0,
    FIXED = 1,
    RELATIVE = 2
}
export function friendlyEnumEventRelativeThresholdType(value: EventRelativeThresholdType): string {
	switch(value) {
		case 0:
			return "OFF"
		case 1:
			return "FIXED"
		case 2:
			return "RELATIVE"
		default:
			return value?.toString()
	}
}

export enum BookingPeriodEnd {
    COURSE_START = 0,
    COURSE_END = 1,
    FIXED = 2,
    RELATIVE = 3,
    RELATIVE_TO_END = 4
}
export function friendlyEnumBookingPeriodEnd(value: BookingPeriodEnd): string {
	switch(value) {
		case 0:
			return "COURSE_START"
		case 1:
			return "COURSE_END"
		case 2:
			return "FIXED"
		case 3:
			return "RELATIVE"
		case 4:
			return "RELATIVE_TO_END"
		default:
			return value?.toString()
	}
}

export enum BookingDateRelativeSpokeRuleMode {
    BEFORE_NOT_INCLUSIVE = 0,
    AFTER_AND_INCLUSIVE = 1
}
export function friendlyEnumBookingDateRelativeSpokeRuleMode(value: BookingDateRelativeSpokeRuleMode): string {
	switch(value) {
		case 0:
			return "BEFORE_NOT_INCLUSIVE"
		case 1:
			return "AFTER_AND_INCLUSIVE"
		default:
			return value?.toString()
	}
}

export enum CourseCapacityConstraintSource {
    NONE = 0,
    COURSE = 1,
    SPOKE_VERSION = 2
}
export function friendlyEnumCourseCapacityConstraintSource(value: CourseCapacityConstraintSource): string {
	switch(value) {
		case 0:
			return "NONE"
		case 1:
			return "COURSE"
		case 2:
			return "SPOKE_VERSION"
		default:
			return value?.toString()
	}
}

export enum PriceLocked {
    NEVER_LOCKED = 0,
    FORCE_UNLOCKED = 1,
    AUTO_LOCKED = 2,
    MANUAL_LOCKED = 3,
    IMPORT_LOCKED = 4
}
export function friendlyEnumPriceLocked(value: PriceLocked): string {
	switch(value) {
		case 0:
			return "NEVER_LOCKED"
		case 1:
			return "FORCE_UNLOCKED"
		case 2:
			return "AUTO_LOCKED"
		case 3:
			return "MANUAL_LOCKED"
		case 4:
			return "IMPORT_LOCKED"
		default:
			return value?.toString()
	}
}

export enum CancellationThreshold {
    OFF = 0,
    FIXED = 1,
    RELATIVE_BOOKING_DATE = 2,
    RELATIVE_CONTRACT_DATE = 3
}
export function friendlyEnumCancellationThreshold(value: CancellationThreshold): string {
	switch(value) {
		case 0:
			return "OFF"
		case 1:
			return "FIXED"
		case 2:
			return "RELATIVE_BOOKING_DATE"
		case 3:
			return "RELATIVE_CONTRACT_DATE"
		default:
			return value?.toString()
	}
}

export enum RefundType {
    NONE = 0,
    FULL = 1,
    FIXED = 2,
    FEE = 3,
    PERCENTAGE = 4,
    DEPOSIT = 5
}
export function friendlyEnumRefundType(value: RefundType): string {
	switch(value) {
		case 0:
			return "NONE"
		case 1:
			return "FULL"
		case 2:
			return "FIXED"
		case 3:
			return "FEE"
		case 4:
			return "PERCENTAGE"
		case 5:
			return "DEPOSIT"
		default:
			return value?.toString()
	}
}

export enum RefundAction {
    FACILITY_DEFAULT = 0,
    STORE_CREDIT = 1,
    REFUND_PAYMENT = 2
}
export function friendlyEnumRefundAction(value: RefundAction): string {
	switch(value) {
		case 0:
			return "FACILITY_DEFAULT"
		case 1:
			return "STORE_CREDIT"
		case 2:
			return "REFUND_PAYMENT"
		default:
			return value?.toString()
	}
}

export enum PlanQuestionType {
    TEXT = 'TEXT',
    PARAGRAPH = 'PARAGRAPH',
    BOOLEAN = 'BOOLEAN',
    NUMBER = 'NUMBER',
    SINGLE_CHOICE = 'SINGLE_CHOICE',
    MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
    PHONE_NUMBER = 'PHONE_NUMBER',
    EMAIL = 'EMAIL'
}
export function friendlyEnumPlanQuestionType(value: PlanQuestionType): string {
	switch(value) {
		case "TEXT":
			return "TEXT"
		case "PARAGRAPH":
			return "PARAGRAPH"
		case "BOOLEAN":
			return "BOOLEAN"
		case "NUMBER":
			return "NUMBER"
		case "SINGLE_CHOICE":
			return "SINGLE_CHOICE"
		case "MULTIPLE_CHOICE":
			return "MULTIPLE_CHOICE"
		case "PHONE_NUMBER":
			return "PHONE_NUMBER"
		case "EMAIL":
			return "EMAIL"
		default:
			return value?.toString()
	}
}

export enum LangStringTypes {
    TEXT = 'text',
    MARKUP = 'markup'
}
export function friendlyEnumLangStringTypes(value: LangStringTypes): string {
	switch(value) {
		case "text":
			return "TEXT"
		case "markup":
			return "MARKUP"
		default:
			return value?.toString()
	}
}

export enum Languages {
    DEFAULT = '',
    ENGLISH = 'english',
    SPANISH_MX = 'spanish-mx',
    FRENCH = 'french',
    GERMAN = 'german'
}
export function friendlyEnumLanguages(value: Languages): string {
	switch(value) {
		case "":
			return "DEFAULT"
		case "english":
			return "English"
		case "spanish-mx":
			return "Spanish"
		case "french":
			return "French"
		case "german":
			return "German"
		default:
			return value?.toString()
	}
}

export enum InsideSessionType {
    FIXED_DATES = 0,
    FIXED_DURATION = 1,
    PERPETUAL = 2
}
export function friendlyEnumInsideSessionType(value: InsideSessionType): string {
	switch(value) {
		case 0:
			return "FIXED_DATES"
		case 1:
			return "FIXED_DURATION"
		case 2:
			return "PERPETUAL"
		default:
			return value?.toString()
	}
}

export enum PupStoredPaymentMethodAccountType {
    NONE = 0,
    CREDIT_CARD = 1,
    BANK_ACCOUNT = 2,
    CUSTOM = 3
}
export function friendlyEnumPupStoredPaymentMethodAccountType(value: PupStoredPaymentMethodAccountType): string {
	switch(value) {
		case 0:
			return "NONE"
		case 1:
			return "CREDIT_CARD"
		case 2:
			return "BANK_ACCOUNT"
		case 3:
			return "CUSTOM"
		default:
			return value?.toString()
	}
}

export enum PupPaymentProvider {
    UNKNOWN = 'UNKNOWN',
    CARD_POINTE = 'CARD_POINTE',
    SQUARE = 'SQUARE',
    STRIPE = 'STRIPE',
    WINDCAVE = 'WINDCAVE'
}
export function friendlyEnumPupPaymentProvider(value: PupPaymentProvider): string {
	switch(value) {
		case "UNKNOWN":
			return "UNKNOWN"
		case "CARD_POINTE":
			return "CARD_POINTE"
		case "SQUARE":
			return "SQUARE"
		case "STRIPE":
			return "STRIPE"
		case "WINDCAVE":
			return "WINDCAVE"
		default:
			return value?.toString()
	}
}

export enum PupPaymentTokenExtendedType {
    UNKNOWN = '',
    CREDIT_CARD = 'CREDIT-CARD',
    CHECKING = 'CHECKING',
    SAVINGS = 'SAVINGS',
    BUSINESS_CHECKING = 'B-CHECKING',
    BUSINESS_SAVINGS = 'B-SAVINGS'
}
export function friendlyEnumPupPaymentTokenExtendedType(value: PupPaymentTokenExtendedType): string {
	switch(value) {
		case "":
			return "UNKNOWN"
		case "CREDIT-CARD":
			return "CREDIT_CARD"
		case "CHECKING":
			return "CHECKING"
		case "SAVINGS":
			return "SAVINGS"
		case "B-CHECKING":
			return "BUSINESS_CHECKING"
		case "B-SAVINGS":
			return "BUSINESS_SAVINGS"
		default:
			return value?.toString()
	}
}

export enum PupPaymentTokenStringPrefixIdentifiers {
    CARD_POINTE = 'CP',
    BANK_US = 'BANK-US',
    STRIPE_PI = 'STRIPE_PI',
    STRIPE_PM = 'STRIPE_PM',
    CUSTOM = 'CUSTOM',
    WINDCAVE = 'WC'
}
export function friendlyEnumPupPaymentTokenStringPrefixIdentifiers(value: PupPaymentTokenStringPrefixIdentifiers): string {
	switch(value) {
		case "CP":
			return "CARD_POINTE"
		case "BANK-US":
			return "BANK_US"
		case "STRIPE_PI":
			return "STRIPE_PI"
		case "STRIPE_PM":
			return "STRIPE_PM"
		case "CUSTOM":
			return "CUSTOM"
		case "WC":
			return "WINDCAVE"
		default:
			return value?.toString()
	}
}

export enum PupHostedPaymentFormCaptureMethod {
    CREDIT_CARD_FORM = 'CREDIT_CARD_FORM',
    CREDIT_CARD_TERMINAL_CARD = 'CREDIT_CARD_TERMINAL_CARD',
    CREDIT_CARD_TERMINAL_KEYED = 'CREDIT_CARD_TERMINAL_KEYED',
    DIRECT_DEBIT = 'DIRECT_DEBIT'
}
export function friendlyEnumPupHostedPaymentFormCaptureMethod(value: PupHostedPaymentFormCaptureMethod): string {
	switch(value) {
		case "CREDIT_CARD_FORM":
			return "CREDIT_CARD_FORM"
		case "CREDIT_CARD_TERMINAL_CARD":
			return "CREDIT_CARD_TERMINAL_CARD"
		case "CREDIT_CARD_TERMINAL_KEYED":
			return "CREDIT_CARD_TERMINAL_KEYED"
		case "DIRECT_DEBIT":
			return "DIRECT_DEBIT"
		default:
			return value?.toString()
	}
}

export enum PaymentSourceFormSelectableTypes {
    SYSTEM = 'SYSTEM',
    CUSTOM = 'CUSTOM',
    CARD_POINTE = 'CARD_POINTE',
    STRIPE = 'STRIPE',
    WINDCAVE = 'WINDCAVE'
}
export function friendlyEnumPaymentSourceFormSelectableTypes(value: PaymentSourceFormSelectableTypes): string {
	switch(value) {
		case "SYSTEM":
			return "SYSTEM"
		case "CUSTOM":
			return "CUSTOM"
		case "CARD_POINTE":
			return "CARD_POINTE"
		case "STRIPE":
			return "STRIPE"
		case "WINDCAVE":
			return "WINDCAVE"
		default:
			return value?.toString()
	}
}

export enum PupCapturePaymentJobMethod {
    UNDEFINED = 'UNDEFINED',
    TERMINAL_KEYED = 'TERMINAL_KEYED',
    TERMINAL_CARD = 'TERMINAL_CARD',
    STORED_PAYMENT_METHOD = 'STORED_PAYMENT_METHOD',
    TOKEN = 'TOKEN'
}
export function friendlyEnumPupCapturePaymentJobMethod(value: PupCapturePaymentJobMethod): string {
	switch(value) {
		case "UNDEFINED":
			return "UNDEFINED"
		case "TERMINAL_KEYED":
			return "TERMINAL_KEYED"
		case "TERMINAL_CARD":
			return "TERMINAL_CARD"
		case "STORED_PAYMENT_METHOD":
			return "STORED_PAYMENT_METHOD"
		case "TOKEN":
			return "TOKEN"
		default:
			return value?.toString()
	}
}

export enum PaymentSourceMethod {
    CASH = 'CASH',
    CHECK = 'CHECK',
    CREDIT_CARD = 'CREDIT_CARD',
    CUSTOM = 'CUSTOM',
    OTHER = 'OTHER',
    DIRECT_DEBIT = 'DIRECT_DEBIT',
    IMPORTED_RGP_STRIPE_ONLINE = 'IMPORTED_RGP_STRIPE_ONLINE',
    IMPORTED_RGP_ALT1 = 'IMPORTED_RGP_ALT1',
    IMPORTED_RGP_ALT2 = 'IMPORTED_RGP_ALT2',
    ARCHIVE = 'ARCHIVE',
    FRONT_END_STUB = 'FRONT_END_STUB',
    INTERAC = 'INTERAC'
}
export function friendlyEnumPaymentSourceMethod(value: PaymentSourceMethod): string {
	switch(value) {
		case "CASH":
			return "CASH"
		case "CHECK":
			return "CHECK"
		case "CREDIT_CARD":
			return "CREDIT_CARD"
		case "CUSTOM":
			return "CUSTOM"
		case "OTHER":
			return "OTHER"
		case "DIRECT_DEBIT":
			return "DIRECT_DEBIT"
		case "IMPORTED_RGP_STRIPE_ONLINE":
			return "IMPORTED_RGP_STRIPE_ONLINE"
		case "IMPORTED_RGP_ALT1":
			return "IMPORTED_RGP_ALT1"
		case "IMPORTED_RGP_ALT2":
			return "IMPORTED_RGP_ALT2"
		case "ARCHIVE":
			return "ARCHIVE"
		case "FRONT_END_STUB":
			return "FRONT_END_STUB"
		case "INTERAC":
			return "INTERAC"
		default:
			return value?.toString()
	}
}

export enum PupStoredCredentialMandateInitiator {
    UNKNOWN = 'UNKNOWN',
    MERCHANT = 'MERCHANT',
    CUSTOMER = 'CUSTOMER'
}
export function friendlyEnumPupStoredCredentialMandateInitiator(value: PupStoredCredentialMandateInitiator): string {
	switch(value) {
		case "UNKNOWN":
			return "UNKNOWN"
		case "MERCHANT":
			return "MERCHANT"
		case "CUSTOMER":
			return "CUSTOMER"
		default:
			return value?.toString()
	}
}

export enum PupTransactionOrigin {
    UNKNOWN = 'UNKNOWN',
    RECURRING = 'RECURRING',
    ECOMMERCE = 'ECOMMERCE',
    TELEPHONE = 'TELEPHONE'
}
export function friendlyEnumPupTransactionOrigin(value: PupTransactionOrigin): string {
	switch(value) {
		case "UNKNOWN":
			return "UNKNOWN"
		case "RECURRING":
			return "RECURRING"
		case "ECOMMERCE":
			return "ECOMMERCE"
		case "TELEPHONE":
			return "TELEPHONE"
		default:
			return value?.toString()
	}
}

export enum DepositCalculationMode {
    UNKNOWN = 'UNKNOWN',
    FIXED = 'FIXED',
    PERCENT = 'PERCENT'
}
export function friendlyEnumDepositCalculationMode(value: DepositCalculationMode): string {
	switch(value) {
		case "UNKNOWN":
			return "UNKNOWN"
		case "FIXED":
			return "FIXED"
		case "PERCENT":
			return "PERCENT"
		default:
			return value?.toString()
	}
}

export enum PlanPricingPaymentDueMode {
    NOTHING = 'NOTHING',
    FULL_AMOUNT = 'FULL_AMOUNT',
    DEPOSIT = 'DEPOSIT'
}
export function friendlyEnumPlanPricingPaymentDueMode(value: PlanPricingPaymentDueMode): string {
	switch(value) {
		case "NOTHING":
			return "NOTHING"
		case "FULL_AMOUNT":
			return "FULL_AMOUNT"
		case "DEPOSIT":
			return "DEPOSIT"
		default:
			return value?.toString()
	}
}

export enum ApiCheckInMode {
    DEFAULT = 'default',
    RECHECK = 'recheck'
}
export function friendlyEnumApiCheckInMode(value: ApiCheckInMode): string {
	switch(value) {
		case "default":
			return "Default Mode"
		case "recheck":
			return "Recheck Mode"
		default:
			return value?.toString()
	}
}

export enum CheckInStatus {
    DENY = 0,
    OK = 1,
    WARN = 2,
    ALERT = 3
}
export function friendlyEnumCheckInStatus(value: CheckInStatus): string {
	switch(value) {
		case 0:
			return "Deny"
		case 1:
			return "OK"
		case 2:
			return "Warn"
		case 3:
			return "Alert"
		default:
			return value?.toString()
	}
}

export enum PlanDocumentDisplayMode {
    INLINE_MODE = 'INLINE_MODE',
    DOCUMENT_MODE = 'DOCUMENT_MODE'
}
export function friendlyEnumPlanDocumentDisplayMode(value: PlanDocumentDisplayMode): string {
	switch(value) {
		case "INLINE_MODE":
			return "INLINE_MODE"
		case "DOCUMENT_MODE":
			return "DOCUMENT_MODE"
		default:
			return value?.toString()
	}
}

export enum PlanDocumentSignatureMode {
    DRAW_ONLY = 'DRAW_ONLY',
    TYPE_ONLY = 'TYPE_ONLY',
    DRAW_OR_TYPE = 'DRAW_OR_TYPE',
    TYPE_OR_DRAW = 'TYPE_OR_DRAW'
}
export function friendlyEnumPlanDocumentSignatureMode(value: PlanDocumentSignatureMode): string {
	switch(value) {
		case "DRAW_ONLY":
			return "DRAW_ONLY"
		case "TYPE_ONLY":
			return "TYPE_ONLY"
		case "DRAW_OR_TYPE":
			return "DRAW_OR_TYPE"
		case "TYPE_OR_DRAW":
			return "TYPE_OR_DRAW"
		default:
			return value?.toString()
	}
}

export enum DocumentSignatureMethod {
    DRAWN = 'DRAWN',
    TYPED = 'TYPED'
}
export function friendlyEnumDocumentSignatureMethod(value: DocumentSignatureMethod): string {
	switch(value) {
		case "DRAWN":
			return "DRAWN"
		case "TYPED":
			return "TYPED"
		default:
			return value?.toString()
	}
}

export enum MarkupSectionLoopMode {
    NONE = 0,
    ALL_ENROLLMENTS = 1,
    SPECIFIC_ENROLLMENT_TYPES = 2
}
export function friendlyEnumMarkupSectionLoopMode(value: MarkupSectionLoopMode): string {
	switch(value) {
		case 0:
			return "NONE"
		case 1:
			return "ALL_ENROLLMENTS"
		case 2:
			return "SPECIFIC_ENROLLMENT_TYPES"
		default:
			return value?.toString()
	}
}

export enum NotificationTemplateStaffEmail {
    ALWAYS = 1,
    PROMPT = 2,
    NEVER = 3
}
export function friendlyEnumNotificationTemplateStaffEmail(value: NotificationTemplateStaffEmail): string {
	switch(value) {
		case 1:
			return "ALWAYS"
		case 2:
			return "PROMPT"
		case 3:
			return "NEVER"
		default:
			return value?.toString()
	}
}

export enum ContractTokenConsumptionMode {
    REQUIRED = 'REQUIRED',
    REPLACE_PRICE = 'REPLACE_PRICE'
}
export function friendlyEnumContractTokenConsumptionMode(value: ContractTokenConsumptionMode): string {
	switch(value) {
		case "REQUIRED":
			return "REQUIRED"
		case "REPLACE_PRICE":
			return "REPLACE_PRICE"
		default:
			return value?.toString()
	}
}

export enum TicketCommentType {
    DRAFT = 0,
    PRIVATE = 1,
    PUBLIC = 2,
    SYSTEM = 3
}
export function friendlyEnumTicketCommentType(value: TicketCommentType): string {
	switch(value) {
		case 0:
			return "Draft"
		case 1:
			return "Private"
		case 2:
			return "Public"
		case 3:
			return "Update"
		default:
			return value?.toString()
	}
}

export enum TicketCommentAction {
    NEW = 0,
    COMMENTED = 1,
    UPDATED = 2,
    ASSIGNED = 3,
    TAGGED = 4,
    DELETED = 100
}
export function friendlyEnumTicketCommentAction(value: TicketCommentAction): string {
	switch(value) {
		case 0:
			return "New"
		case 1:
			return "Commented"
		case 2:
			return "Updated"
		case 3:
			return "Assigned"
		case 4:
			return "Tagged"
		case 100:
			return "Deleted"
		default:
			return value?.toString()
	}
}

export enum TicketRoutingSource {
    THAW = 1,
    TERMINATE = 2,
    FREEZE = 3,
    CANCEL = 4,
    CONTACT_US_CONTRACT = 5,
    MOBILE_PROFILE_DELETION_REQUEST = 6,
    CONTACT_US = 7
}
export function friendlyEnumTicketRoutingSource(value: TicketRoutingSource): string {
	switch(value) {
		case 1:
			return "THAW"
		case 2:
			return "TERMINATE"
		case 3:
			return "FREEZE"
		case 4:
			return "CANCEL"
		case 5:
			return "CONTACT_US_CONTRACT"
		case 6:
			return "MOBILE_PROFILE_DELETION_REQUEST"
		case 7:
			return "CONTACT_US"
		default:
			return value?.toString()
	}
}

export enum PlanQuestionSize {
    SMALL = 'SMALL',
    MEDIUM = 'MEDIUM',
    LARGE = 'LARGE'
}
export function friendlyEnumPlanQuestionSize(value: PlanQuestionSize): string {
	switch(value) {
		case "SMALL":
			return "SMALL"
		case "MEDIUM":
			return "MEDIUM"
		case "LARGE":
			return "LARGE"
		default:
			return value?.toString()
	}
}

export enum SingleChoiceQuestionInputType {
    DROPDOWN = 'DROPDOWN',
    RADIO_BUTTON_LIST = 'RADIO_BUTTON_LIST'
}
export function friendlyEnumSingleChoiceQuestionInputType(value: SingleChoiceQuestionInputType): string {
	switch(value) {
		case "DROPDOWN":
			return "DROPDOWN"
		case "RADIO_BUTTON_LIST":
			return "RADIO_BUTTON_LIST"
		default:
			return value?.toString()
	}
}

export enum StorefrontIconGlyph {
    NONE = 'NONE',
    SHOPPING_BAG = 'SHOPPING_BAG',
    MOUNTAIN = 'MOUNTAIN',
    PERSON = 'PERSON'
}
export function friendlyEnumStorefrontIconGlyph(value: StorefrontIconGlyph): string {
	switch(value) {
		case "NONE":
			return "NONE"
		case "SHOPPING_BAG":
			return "SHOPPING_BAG"
		case "MOUNTAIN":
			return "MOUNTAIN"
		case "PERSON":
			return "PERSON"
		default:
			return value?.toString()
	}
}

export enum ContractToCustomerFieldAssignmentScope {
    NONE = 'NONE',
    CONTRACT_HOLDER = 'CONTRACT_HOLDER',
    ALL_ENROLLMENTS = 'ALL_ENROLLMENTS',
    EVERYONE = 'EVERYONE'
}
export function friendlyEnumContractToCustomerFieldAssignmentScope(value: ContractToCustomerFieldAssignmentScope): string {
	switch(value) {
		case "NONE":
			return "Do not assign to any customer records"
		case "CONTRACT_HOLDER":
			return "Assign to only the contract holder customer record"
		case "ALL_ENROLLMENTS":
			return "Assign to all enrollment customer records"
		case "EVERYONE":
			return "Assign to all contract customer records"
		default:
			return value?.toString()
	}
}

export enum FacilityGlobalAlertLevel {
    ALERT = 'alert',
    HIGHLIGHT = 'highlight'
}
export function friendlyEnumFacilityGlobalAlertLevel(value: FacilityGlobalAlertLevel): string {
	switch(value) {
		case "alert":
			return "Alert"
		case "highlight":
			return "Highlight"
		default:
			return value?.toString()
	}
}

export enum CustomAttributeType {
    CURRENCY = 'CURRENCY',
    INTEGER = 'INTEGER',
    FLOAT = 'FLOAT',
    TEXT = 'TEXT',
    PARAGRAPH = 'PARAGRAPH',
    BOOLEAN = 'BOOLEAN',
    SET = 'SET',
    DATE = 'DATE',
    DATETIME = 'DATETIME'
}
export function friendlyEnumCustomAttributeType(value: CustomAttributeType): string {
	switch(value) {
		case "CURRENCY":
			return "Currency"
		case "INTEGER":
			return "Integer"
		case "FLOAT":
			return "Float"
		case "TEXT":
			return "Text"
		case "PARAGRAPH":
			return "Paragraph"
		case "BOOLEAN":
			return "Toggle Button"
		case "SET":
			return "List"
		case "DATE":
			return "Date without time"
		case "DATETIME":
			return "Date"
		default:
			return value?.toString()
	}
}

export enum CompositeCourseEndDateMode {
    NONE = 'none',
    SPECIFIC = 'specific',
    FOREVER = 'forever'
}
export function friendlyEnumCompositeCourseEndDateMode(value: CompositeCourseEndDateMode): string {
	switch(value) {
		case "none":
			return "NONE"
		case "specific":
			return "SPECIFIC"
		case "forever":
			return "FOREVER"
		default:
			return value?.toString()
	}
}

export enum DoNotMailChoiceType {
    OPT_OUT = 0,
    OPT_IN = 1
}
export function friendlyEnumDoNotMailChoiceType(value: DoNotMailChoiceType): string {
	switch(value) {
		case 0:
			return "Opt Out"
		case 1:
			return "Opt In"
		default:
			return value?.toString()
	}
}

export enum PlanTemplateType {
    NEW_CONTRACT = 'NEW_CONTRACT',
    CURRENT_CONTRACT = 'CURRENT_CONTRACT',
    EXPIRING_CONTRACT = 'EXPIRING_CONTRACT',
    EXPIRED_CONTRACT = 'EXPIRED_CONTRACT',
    CANCELLED_CONTRACT = 'CANCELLED_CONTRACT',
    UPCOMING_THAW = 'UPCOMING_THAW',
    UPCOMING_TERMINATE = 'UPCOMING_TERMINATE',
    THAW_EFFECTIVE = 'THAW_EFFECTIVE',
    FREEZE_REQUESTED = 'FREEZE_REQUESTED',
    FREEZE_EFFECTIVE = 'FREEZE_EFFECTIVE',
    TERMINATE_REQUESTED = 'TERMINATE_REQUESTED',
    TERMINATE_EFFECTIVE = 'TERMINATE_EFFECTIVE',
    COURSE_REMINDER = 'COURSE_REMINDER',
    COURSE_THANK_YOU = 'COURSE_THANK_YOU',
    SESSION_REMINDER = 'SESSION_REMINDER',
    SESSION_THANK_YOU = 'SESSION_THANK_YOU'
}

export enum ContentTemplateType {
    EMAIL = 'EMAIL',
    DOCUMENT = 'DOCUMENT',
    SMS = 'SMS'
}

export enum ChartingSpecialNodeKeys {
    SALES = 'sales',
    SALES_ACCOUNT = 'sales-account',
    SALES_ANALYTICS = 'sales-analytics',
    SALES_ANALYTICS_MONTHLY_SALES_BY_YEAR = 'sales-analytics-monthly-sales-by-year',
    SALES_ANALYTICS_CUMULATIVE_SALES_BY_YEAR_YTD = 'sales-analytics-cumulative-sales-by-year-ytd',
    SALES_ANALYTICS_CUMULATIVE_SALES_PERCENT_YTD = 'sales-analytics-cumulative-sales-percent-ytd',
    SALES_ANALYTICS_MONTHLY_SALES_PERCENT = 'sales-analytics-monthly-sales-percent',
    SALES_ANALYTICS_SEGMENT_CONTRIBUTION = 'sales-analytics-segment-contribution',
    SALES_PRODUCTS = 'sales-products',
    SALES_PRODUCTS_REVENUE = 'sales-products-revenue',
    SALES_PRODUCTS_QUANTITY = 'sales-products-quantity',
    SALES_ACCOUNT_REVENUE = 'sales-account-revenue',
    SALES_ACCOUNT_QUANTITY = 'sales-account-quantity',
    PLANS = 'plans',
    PLANS_BADGED_ENROLLMENTS = 'plan-badged-enrollments',
    PLANS_PROGRAMS = 'plans-programs',
    PLANS_PROGRAMS_CAPACITY_TREND = 'plans-programs-capacity-trend',
    PLANS_PROGRAMS_FACILITY_COMPARISON = 'plans-programs-facility-comparison',
    PLANS_CONTRACTS = 'plan-contracts-contracts',
    PLANS_CONTRACTS_EXPERIMENTAL = 'plan-contracts-experimental',
    PLANS_ENROLLMENTS = 'plan-contracts-enrollments',
    PLANS_ENROLLMENTS_EXPERIMENTAL = 'plan-contracts-enrollments-experimental',
    CHECK_INS = 'check-ins',
    CHECK_IN_COUNT = 'check-ins-count',
    CHECK_IN_SESSION = 'check-ins-session',
    CHECK_IN_RETURNING_VISITOR_DISTRIBUTION = 'check-ins-returning-visitor-distribution',
    CHECK_IN_MEMBERSHIP_CONVERSION_VELOCITY = 'check-ins-membership-conversion-velocity',
    CHECK_IN_REV_PER_VISIT = 'check-ins-avg-rev-per-visit',
    CUSTOMERS = 'customers',
    CUSTOMERS_NEW = 'customers-new',
    CUSTOMERS_FIRST_VISIT = 'customers-first-visit',
    CUSTOMERS_ONLINE_PROFILES = 'customers-online-profiles',
    EMAIL = 'email',
    EMAIL_AUTOMATIONS = 'email-automations',
    TICKETS = 'tickets',
    TICKETS_RECEIVED = 'ticket-incoming-count',
    TICKETS_RESOLVED_BY_STAFF = 'ticket-resolved-by-staff-count',
    TICKETS_STATUS_SNAPSHOT = 'ticket-status-snapshot',
    PROMOTIONS = 'promotions',
    PROMOTIONS_CODES = 'promotions-codes',
    PROMOTION_REDEMPTION_LOG = 'promotion-redemption-log',
    PROMOTION_REDEMPTION_REVENUE = 'promotion-redemption-revenue',
    MISC = 'misc',
    MISC_CARD_UPDATER_ACTIVITY = 'misc-card-updater-activity',
    LEGACY = 'legacy',
    LEGACY_RGP_DAILY_NUMBERS = 'legacy-rgp-daily-numbers',
    MEMBERSHIP_ANALYTICS = 'membership-analytics',
    MEMBERSHIP_ANALYTICS_CHURN = 'membership-analytics-churn',
    MEMBERSHIP_ANALYTICS_RETENTION = 'membership-analytics-retention',
    MEMBERSHIP_AVERAGE_CHECKINS = 'membership-average-checkins'
}

export enum ContractStatusReporting {
    BOOKED = 'BOOKED',
    STARTED = 'STARTED',
    ENDED = 'ENDED',
    CANCELLED = 'CANCELLED'
}
export function friendlyEnumContractStatusReporting(value: ContractStatusReporting): string {
	switch(value) {
		case "BOOKED":
			return "Booked"
		case "STARTED":
			return "Started"
		case "ENDED":
			return "Ended"
		case "CANCELLED":
			return "Cancelled"
		default:
			return value?.toString()
	}
}

export enum ContractPlanSetModelFilterType {
    BILLING_TYPE = 'BILLING_TYPE',
    PLAN_TYPE = 'PLAN_TYPE',
    PLAN = 'PLAN',
    CUSTOMER_BADGE = 'CUSTOMER_BADGE',
    PLAN_DIRECTORY = 'PLAN_DIRECTORY',
    KEY_MEMBERSHIPS = 'KEY_MEMBERSHIPS'
}
export function friendlyEnumContractPlanSetModelFilterType(value: ContractPlanSetModelFilterType): string {
	switch(value) {
		case "BILLING_TYPE":
			return "BILLING_TYPE"
		case "PLAN_TYPE":
			return "PLAN_TYPE"
		case "PLAN":
			return "PLAN"
		case "CUSTOMER_BADGE":
			return "CUSTOMER_BADGE"
		case "PLAN_DIRECTORY":
			return "PLAN_DIRECTORY"
		case "KEY_MEMBERSHIPS":
			return "Key Membership Plans"
		default:
			return value?.toString()
	}
}

export enum EnrollmentStatusReporting {
    ACTIVE = 'ACTIVE',
    STARTED = 'STARTED',
    ENDED = 'ENDED',
    CANCELLED = 'CANCELLED',
    ACTIVE_ONLY = 'ACTIVE_ONLY',
    FROZEN_ONLY = 'FROZEN_ONLY',
    ACTIVE_EXCLUSIVELY = 'ACTIVE_EXCLUSIVELY',
    FROZEN_EXCLUSIVELY = 'FROZEN_EXCLUSIVELY'
}
export function friendlyEnumEnrollmentStatusReporting(value: EnrollmentStatusReporting): string {
	switch(value) {
		case "ACTIVE":
			return "Active"
		case "STARTED":
			return "Started"
		case "ENDED":
			return "Ended"
		case "CANCELLED":
			return "Cancelled"
		case "ACTIVE_ONLY":
			return "Active (at any point within period)"
		case "FROZEN_ONLY":
			return "Frozen (at any point within period)"
		case "ACTIVE_EXCLUSIVELY":
			return "Active (never frozen)"
		case "FROZEN_EXCLUSIVELY":
			return "Frozen (never active)"
		default:
			return value?.toString()
	}
}

export enum AutoEmailedReportsFrequency {
    HOURLY = 'HOURLY',
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    BIWEEKLY = 'BIWEEKLY',
    MONTHLY = 'MONTHLY',
    QUARTERLY = 'QUARTERLY'
}
export function friendlyEnumAutoEmailedReportsFrequency(value: AutoEmailedReportsFrequency): string {
	switch(value) {
		case "HOURLY":
			return "Hourly"
		case "DAILY":
			return "Daily"
		case "WEEKLY":
			return "Weekly"
		case "BIWEEKLY":
			return "Bi-Weekly"
		case "MONTHLY":
			return "Monthly"
		case "QUARTERLY":
			return "Quarterly"
		default:
			return value?.toString()
	}
}

export enum PlanDirectoryNodeType {
    CATEGORY = 0,
    PLAN = 1
}
export function friendlyEnumPlanDirectoryNodeType(value: PlanDirectoryNodeType): string {
	switch(value) {
		case 0:
			return "CATEGORY"
		case 1:
			return "PLAN"
		default:
			return value?.toString()
	}
}

export enum PlanContractFacilityTransferPolicy {
    PREVENT = 1,
    STAY = 2,
    FOLLOW = 3
}
export function friendlyEnumPlanContractFacilityTransferPolicy(value: PlanContractFacilityTransferPolicy): string {
	switch(value) {
		case 1:
			return "PREVENT - Prevent facility transfers when customer has active contract"
		case 2:
			return "STAY - Contract does not affect home facility"
		case 3:
			return "FOLLOW - Customer's home facility follows this contract to new facility"
		default:
			return value?.toString()
	}
}

export enum PlanBlueprintType {
    REDPOINT = 0,
    MIGRATED = 1,
    ORGANIZATION = 2
}
export function friendlyEnumPlanBlueprintType(value: PlanBlueprintType): string {
	switch(value) {
		case 0:
			return "Built-In "
		case 1:
			return "Migrated"
		case 2:
			return "Custom"
		default:
			return value?.toString()
	}
}

export enum EchoRequestDwellMode {
    AWAIT = 0,
    NEXT_TICK = 1,
    DELAY = 2
}
export function friendlyEnumEchoRequestDwellMode(value: EchoRequestDwellMode): string {
	switch(value) {
		case 0:
			return "AWAIT"
		case 1:
			return "NEXT_TICK"
		case 2:
			return "DELAY"
		default:
			return value?.toString()
	}
}

export enum StandaloneEmailType {
    NOT_DEFINED = '',
    CUSTOMER_LIST = 'CUSTOMER_LIST',
    COURSE_CONTRACT_HOLDERS = 'COURSE_CONTRACT_HOLDERS',
    COURSE_ENROLLMENTS = 'COURSE_ENROLLMENTS',
    COURSE_EVERYONE = 'COURSE_EVERYONE',
    COURSE_WAITLIST = 'COURSE_WAITLIST',
    COURSE_WAITLIST_EVERYONE = 'COURSE_WAITLIST_EVERYONE'
}
export function friendlyEnumStandaloneEmailType(value: StandaloneEmailType): string {
	switch(value) {
		case "":
			return "NOT_DEFINED"
		case "CUSTOMER_LIST":
			return "CUSTOMER_LIST"
		case "COURSE_CONTRACT_HOLDERS":
			return "COURSE_CONTRACT_HOLDERS"
		case "COURSE_ENROLLMENTS":
			return "COURSE_ENROLLMENTS"
		case "COURSE_EVERYONE":
			return "COURSE_EVERYONE"
		case "COURSE_WAITLIST":
			return "COURSE_WAITLIST"
		case "COURSE_WAITLIST_EVERYONE":
			return "COURSE_WAITLIST_EVERYONE"
		default:
			return value?.toString()
	}
}

export enum RichEmailDesignConfigType {
    NONE = '',
    UNLAYER = 'UNLAYER',
    SENDGRID_TEMPLATE = 'SENDGRID_TEMPLATE'
}
export function friendlyEnumRichEmailDesignConfigType(value: RichEmailDesignConfigType): string {
	switch(value) {
		case "":
			return "NONE"
		case "UNLAYER":
			return "UNLAYER"
		case "SENDGRID_TEMPLATE":
			return "SENDGRID_TEMPLATE"
		default:
			return value?.toString()
	}
}

export enum CustomerNotePriority {
    STANDARD = 'STANDARD',
    IMPORTANT = 'IMPORTANT'
}
export function friendlyEnumCustomerNotePriority(value: CustomerNotePriority): string {
	switch(value) {
		case "STANDARD":
			return "Standard"
		case "IMPORTANT":
			return "Important"
		default:
			return value?.toString()
	}
}

export enum SweepBillingMode {
    FIXED_DAYS_OF_MONTH = 0,
    ROLLING = 1
}
export function friendlyEnumSweepBillingMode(value: SweepBillingMode): string {
	switch(value) {
		case 0:
			return "FIXED_DAYS_OF_MONTH"
		case 1:
			return "ROLLING"
		default:
			return value?.toString()
	}
}

export enum PaymentSourceProvider {
    TERMINAL = 'TERMINAL',
    IMPORTED_XCHARGE = 'IMPORTED_XCHARGE',
    IMPORTED_TERMINAL = 'IMPORTED_TERMINAL',
    IMPORTED_ACHWORKS = 'IMPORTED_ACHWORKS',
    IMPORTED_RGPONLINE = 'IMPORTED_RGPONLINE',
    CARD_POINTE = 'CARD_POINTE',
    STRIPE = 'STRIPE',
    WINDCAVE = 'WINDCAVE'
}
export function friendlyEnumPaymentSourceProvider(value: PaymentSourceProvider): string {
	switch(value) {
		case "TERMINAL":
			return "Terminal"
		case "IMPORTED_XCHARGE":
			return "Imported XCharge"
		case "IMPORTED_TERMINAL":
			return "Imported Terminal"
		case "IMPORTED_ACHWORKS":
			return "Imported ACHWorks"
		case "IMPORTED_RGPONLINE":
			return "Imported RGP Online"
		case "CARD_POINTE":
			return "Card Pointe/Fiserv"
		case "STRIPE":
			return "Stripe"
		case "WINDCAVE":
			return "Windcave"
		default:
			return value?.toString()
	}
}

export enum LateFeeType {
    BILLING = 'BILLING',
    OTHER = 'OTHER'
}
export function friendlyEnumLateFeeType(value: LateFeeType): string {
	switch(value) {
		case "BILLING":
			return "BILLING"
		case "OTHER":
			return "OTHER"
		default:
			return value?.toString()
	}
}

export enum KitchenSinkTemporalExpressionMode {
    EVERY_DAY = 'EVERY_DAY',
    DAYS_OF_WEEK = 'DAYS_OF_WEEK',
    WEEKS_OF_MONTH = 'WEEKS_OF_MONTH',
    DAYS_OF_MONTH = 'DAYS_OF_MONTH',
    EVERY_NTH_DAY = 'EVERY_NTH_DAY',
    YEARLY = 'YEARLY'
}
export function friendlyEnumKitchenSinkTemporalExpressionMode(value: KitchenSinkTemporalExpressionMode): string {
	switch(value) {
		case "EVERY_DAY":
			return "Every Day"
		case "DAYS_OF_WEEK":
			return "Days of Week"
		case "WEEKS_OF_MONTH":
			return "Weeks of Month"
		case "DAYS_OF_MONTH":
			return "Days of Month"
		case "EVERY_NTH_DAY":
			return "Every Nth Day"
		case "YEARLY":
			return "Yearly"
		default:
			return value?.toString()
	}
}

export enum KitchenSinkDayOfMonth {
    DAY_LAST = '-1',
    DAY_1 = '1',
    DAY_2 = '2',
    DAY_3 = '3',
    DAY_4 = '4',
    DAY_5 = '5',
    DAY_6 = '6',
    DAY_7 = '7',
    DAY_8 = '8',
    DAY_9 = '9',
    DAY_10 = '10',
    DAY_11 = '11',
    DAY_12 = '12',
    DAY_13 = '13',
    DAY_14 = '14',
    DAY_15 = '15',
    DAY_16 = '16',
    DAY_17 = '17',
    DAY_18 = '18',
    DAY_19 = '19',
    DAY_20 = '20',
    DAY_21 = '21',
    DAY_22 = '22',
    DAY_23 = '23',
    DAY_24 = '24',
    DAY_25 = '25',
    DAY_26 = '26',
    DAY_27 = '27',
    DAY_28 = '28'
}
export function friendlyEnumKitchenSinkDayOfMonth(value: KitchenSinkDayOfMonth): string {
	switch(value) {
		case "-1":
			return "Last"
		case "1":
			return "1st"
		case "2":
			return "2nd"
		case "3":
			return "3rd"
		case "4":
			return "4th"
		case "5":
			return "5th"
		case "6":
			return "6th"
		case "7":
			return "7th"
		case "8":
			return "8th"
		case "9":
			return "9th"
		case "10":
			return "10th"
		case "11":
			return "11th"
		case "12":
			return "12th"
		case "13":
			return "13th"
		case "14":
			return "14th"
		case "15":
			return "15th"
		case "16":
			return "16th"
		case "17":
			return "17th"
		case "18":
			return "18th"
		case "19":
			return "19th"
		case "20":
			return "20th"
		case "21":
			return "21st"
		case "22":
			return "22nd"
		case "23":
			return "23rd"
		case "24":
			return "24th"
		case "25":
			return "25th"
		case "26":
			return "26th"
		case "27":
			return "27th"
		case "28":
			return "28th"
		default:
			return value?.toString()
	}
}

export enum KitchenSinkDaysOfWeek {
    MONDAYS = 'MONDAYS',
    TUESDAYS = 'TUESDAYS',
    WEDNESDAYS = 'WEDNESDAYS',
    THURSDAYS = 'THURSDAYS',
    FRIDAYS = 'FRIDAYS',
    SATURDAYS = 'SATURDAYS',
    SUNDAYS = 'SUNDAYS'
}
export function friendlyEnumKitchenSinkDaysOfWeek(value: KitchenSinkDaysOfWeek): string {
	switch(value) {
		case "MONDAYS":
			return "Mondays"
		case "TUESDAYS":
			return "Tuesdays"
		case "WEDNESDAYS":
			return "Wednesdays"
		case "THURSDAYS":
			return "Thursdays"
		case "FRIDAYS":
			return "Fridays"
		case "SATURDAYS":
			return "Saturdays"
		case "SUNDAYS":
			return "Sundays"
		default:
			return value?.toString()
	}
}

export enum KitchenSinkWeekOfMonth {
    FIRST = '1',
    SECOND = '2',
    THIRD = '3',
    FOURTH = '4'
}
export function friendlyEnumKitchenSinkWeekOfMonth(value: KitchenSinkWeekOfMonth): string {
	switch(value) {
		case "1":
			return "1st"
		case "2":
			return "2nd"
		case "3":
			return "3rd"
		case "4":
			return "4th"
		default:
			return value?.toString()
	}
}

export enum DashboardDateShortcut {
    TODAY = 't',
    H24 = '24h',
    H72 = '72h',
    H168 = '168h',
    D3 = '3d',
    W1 = '1w',
    M1 = '1m',
    M3 = '3m',
    M6 = '6m',
    Y1 = '1y',
    PM1 = 'p1m',
    PM3 = 'p3m',
    PM6 = 'p6m',
    PY1 = 'p1y'
}
export function friendlyEnumDashboardDateShortcut(value: DashboardDateShortcut): string {
	switch(value) {
		case "t":
			return "Today"
		case "24h":
			return "24h"
		case "72h":
			return "72h"
		case "168h":
			return "168h"
		case "3d":
			return "3d"
		case "1w":
			return "1w"
		case "1m":
			return "1m"
		case "3m":
			return "3m"
		case "6m":
			return "6m"
		case "1y":
			return "1y"
		case "p1m":
			return "p1m"
		case "p3m":
			return "p3m"
		case "p6m":
			return "p6m"
		case "p1y":
			return "p1y"
		default:
			return value?.toString()
	}
}

export enum PromotionCodeProvisionMode {
    FIXED = 'F',
    GENERATED = 'G'
}
export function friendlyEnumPromotionCodeProvisionMode(value: PromotionCodeProvisionMode): string {
	switch(value) {
		case "F":
			return "Fixed Codes"
		case "G":
			return "Generated Codes"
		default:
			return value?.toString()
	}
}

export enum MigrationGDriveFileStatus {
    NONE = 0,
    FILE_PENDING_TRANSFER = 10,
    FILE_TRANSFERRING = 20,
    FILE_TRANSFER_COMPLETE = 30,
    DATABASE_LOADING = 40,
    DATABASE_LOAD_COMPLETE = 50,
    ERROR = 100
}
export function friendlyEnumMigrationGDriveFileStatus(value: MigrationGDriveFileStatus): string {
	switch(value) {
		case 0:
			return ""
		case 10:
			return "-- Queued For Transfer --"
		case 20:
			return "-- Transferring --"
		case 30:
			return "Transferred"
		case 40:
			return "-- Loading --"
		case 50:
			return "Loaded"
		case 100:
			return "ERROR"
		default:
			return value?.toString()
	}
}

export enum MigrationSchemaType {
    RGP = 1,
    APPROACH = 2,
    MBO = 3,
    GYM_MASTER = 4,
    CSV = 5
}
export function friendlyEnumMigrationSchemaType(value: MigrationSchemaType): string {
	switch(value) {
		case 1:
			return "RGP"
		case 2:
			return "APPROACH"
		case 3:
			return "MBO"
		case 4:
			return "GYM_MASTER"
		case 5:
			return "CSV"
		default:
			return value?.toString()
	}
}

export enum AIChatMessageRole {
    SYSTEM = 1,
    USER = 2,
    ASSISTANT = 3
}
export function friendlyEnumAIChatMessageRole(value: AIChatMessageRole): string {
	switch(value) {
		case 1:
			return "SYSTEM"
		case 2:
			return "USER"
		case 3:
			return "ASSISTANT"
		default:
			return value?.toString()
	}
}

export enum AIChatSystemPromptIdentifiers {
    CUSTOM = 0,
    SQL_GENERATOR = 1,
    SQL_CHART_GENERATOR = 2
}
export function friendlyEnumAIChatSystemPromptIdentifiers(value: AIChatSystemPromptIdentifiers): string {
	switch(value) {
		case 0:
			return "CUSTOM"
		case 1:
			return "SQL_GENERATOR"
		case 2:
			return "SQL_CHART_GENERATOR"
		default:
			return value?.toString()
	}
}

export enum AIChatTurnPurpose {
    SQL = 'sql',
    CHART_DESIGN = 'chart_design'
}
export function friendlyEnumAIChatTurnPurpose(value: AIChatTurnPurpose): string {
	switch(value) {
		case "sql":
			return "SQL"
		case "chart_design":
			return "CHART_DESIGN"
		default:
			return value?.toString()
	}
}

export enum CustomSqlRunnerErrorType {
    TIMEOUT = 'TIMEOUT',
    INVALID_PARAMETER_COUNT = 'INVALID_PARAMETER_COUNT',
    UNKNOWN = 'UNKNOWN'
}
export function friendlyEnumCustomSqlRunnerErrorType(value: CustomSqlRunnerErrorType): string {
	switch(value) {
		case "TIMEOUT":
			return "TIMEOUT"
		case "INVALID_PARAMETER_COUNT":
			return "INVALID_PARAMETER_COUNT"
		case "UNKNOWN":
			return "UNKNOWN"
		default:
			return value?.toString()
	}
}

export enum RedpointFeatureEnablement {
    DISPATCH_PUSH_NOTIFICATIONS = 'dispatch-push-notifications',
    WEBHOOK_RECV_QUEUE = 'webhook-recv-queue',
    WINDCAVE_TERMINAL = 'windcave-terminal',
    JSON_PRODUCT_TOOLS = 'json-product-tools',
    EXTERNAL_PRODUCT_IFRAME = 'external-product-iframe',
    UNIVERSAL_CURRENCY = 'universal-currency',
    SERVICES_BACKUP_DOWNLOADS = 'services-backup-downloads',
    MULTI_LANGUAGE = 'multi-language',
    LOCALE_LANGUAGE_FILE_GRIDS = 'locale-language-file-grids',
    DEV_STRING_USAGE_LOGGING = 'dev-string-usage-logging',
    PROMOTION_CONTRACT_START_DATES = 'promotion-contract-start-dates',
    REDPOINT_ACCESS = 'redpoint_access',
    STRIPE_FRAUD_DETECTION = 'stripe-fraud-detection',
    TURN_OFF_ZEUS_DATABASE_CREATION_SANITIZED_CONFIG = 'turn-off-zeus-database-creation-sanitized-config',
    SHOPIFY_TOOLS = 'shopify-tools',
    LOYALTY_PROGRAMS = 'loyalty-programs',
    MARKETING_EMAIL_PREFERENCE_TRACKING = 'marketing-email-preference-tracking',
    SPARK_ANALYSIS = 'spark-analysis'
}
export function friendlyEnumRedpointFeatureEnablement(value: RedpointFeatureEnablement): string {
	switch(value) {
		case "dispatch-push-notifications":
			return "Dispatch Push Notifications"
		case "webhook-recv-queue":
			return "WEBHOOK_RECV_QUEUE"
		case "windcave-terminal":
			return "WINDCAVE_TERMINAL"
		case "json-product-tools":
			return "JSON_PRODUCT_TOOLS"
		case "external-product-iframe":
			return "EXTERNAL_PRODUCT_IFRAME"
		case "universal-currency":
			return "UNIVERSAL_CURRENCY"
		case "services-backup-downloads":
			return "SERVICES_BACKUP_DOWNLOADS"
		case "multi-language":
			return "MULTI_LANGUAGE"
		case "locale-language-file-grids":
			return "LOCALE_LANGUAGE_FILE_GRIDS"
		case "dev-string-usage-logging":
			return "DEV_STRING_USAGE_LOGGING"
		case "promotion-contract-start-dates":
			return "PROMOTION_CONTRACT_START_DATES"
		case "redpoint_access":
			return "REDPOINT_ACCESS"
		case "stripe-fraud-detection":
			return "Stripe Fraud Detection"
		case "turn-off-zeus-database-creation-sanitized-config":
			return "Turn Off Zeus Database Creation Sanitized/Config"
		case "shopify-tools":
			return "Shopify Tools"
		case "loyalty-programs":
			return "LOYALTY_PROGRAMS"
		case "marketing-email-preference-tracking":
			return "MARKETING_EMAIL_PREFERENCE_TRACKING"
		case "spark-analysis":
			return "Ask Spark"
		default:
			return value?.toString()
	}
}

export enum StorefrontEngagementLogState {
    VIEWED = 10,
    CONTRACT_STARTED = 20,
    CONTRACT_FINISHED = 30,
    CREATE_CHECKOUT = 40,
    CONTRACT_ACTIVATED = 50
}
export function friendlyEnumStorefrontEngagementLogState(value: StorefrontEngagementLogState): string {
	switch(value) {
		case 10:
			return "VIEWED"
		case 20:
			return "CONTRACT_STARTED"
		case 30:
			return "CONTRACT_FINISHED"
		case 40:
			return "CREATE_CHECKOUT"
		case 50:
			return "CONTRACT_ACTIVATED"
		default:
			return value?.toString()
	}
}

export enum AIChatContextOpinion {
    UNKNOWN = 0,
    LIKED = 10
}
export function friendlyEnumAIChatContextOpinion(value: AIChatContextOpinion): string {
	switch(value) {
		case 0:
			return "UNKNOWN"
		case 10:
			return "LIKED"
		default:
			return value?.toString()
	}
}

export enum AIChatHistoryType {
    REPORT_BUILDER = 'report_builder',
    CHART_BUILDER = 'chart_builder',
    SEGMENT_BUILDER = 'segment_builder',
    INSIGHTS_SEARCH = 'insights_search'
}
export function friendlyEnumAIChatHistoryType(value: AIChatHistoryType): string {
	switch(value) {
		case "report_builder":
			return "REPORT_BUILDER"
		case "chart_builder":
			return "CHART_BUILDER"
		case "segment_builder":
			return "SEGMENT_BUILDER"
		case "insights_search":
			return "INSIGHTS_SEARCH"
		default:
			return value?.toString()
	}
}

export enum WaitlistStatus {
    BOOKING = 0,
    WAITLISTED = 1,
    BOOKED = 2,
    REMOVED = 3
}
export function friendlyEnumWaitlistStatus(value: WaitlistStatus): string {
	switch(value) {
		case 0:
			return "Eligible to Book"
		case 1:
			return "Waitlisted"
		case 2:
			return "Booked"
		case 3:
			return "Removed"
		default:
			return value?.toString()
	}
}

export enum OpenAIModel {
    FOUR_ONE_MINI = 'gpt-4.1-mini',
    FIVE_MINI = 'gpt-5-mini',
    FIVE_FOUR_MINI = 'gpt-5.4-mini',
    FIVE_FOUR = 'gpt-5.4',
    FIVE_FULL = 'gpt-5',
    FIVE_SIX_LUNA = 'gpt-5.6-luna',
    SIX_LUNA = 'gpt-6-luna',
    FIVE_SIX_TERRA = 'gpt-5.6-terra',
    FIVE_SIX_SOL = 'gpt-5.6-sol',
    SIX_ONE_SOL = 'gpt-6.1-sol',
    SIX_ASTRA = 'gpt-6-astra'
}
export function friendlyEnumOpenAIModel(value: OpenAIModel): string {
	switch(value) {
		case "gpt-4.1-mini":
			return "FOUR_ONE_MINI"
		case "gpt-5-mini":
			return "FIVE_MINI"
		case "gpt-5.4-mini":
			return "FIVE_FOUR_MINI"
		case "gpt-5.4":
			return "FIVE_FOUR"
		case "gpt-5":
			return "FIVE_FULL"
		case "gpt-5.6-luna":
			return "FIVE_SIX_LUNA"
		case "gpt-6-luna":
			return "SIX_LUNA"
		case "gpt-5.6-terra":
			return "FIVE_SIX_TERRA"
		case "gpt-5.6-sol":
			return "FIVE_SIX_SOL"
		case "gpt-6.1-sol":
			return "SIX_ONE_SOL"
		case "gpt-6-astra":
			return "SIX_ASTRA"
		default:
			return value?.toString()
	}
}

export enum TicketStatus {
    NEW = 0,
    AWAITING_REPLY = 1,
    ACTION_NEEDED = 2,
    OPEN = 3,
    RESOLVED = 4
}
export function friendlyEnumTicketStatus(value: TicketStatus): string {
	switch(value) {
		case 0:
			return "New"
		case 1:
			return "Awaiting Reply"
		case 2:
			return "Action Needed"
		case 3:
			return "Open"
		case 4:
			return "Resolved"
		default:
			return value?.toString()
	}
}

export enum DispatchCampaignStatus {
    DRAFT = 0,
    SCHEDULED = 10,
    QUEUING = 20,
    SENDING = 40,
    PAUSED = 50,
    SUSPENDED = 55,
    ABORTED = 60,
    SENT = 70,
    ERRORED = 100
}
export function friendlyEnumDispatchCampaignStatus(value: DispatchCampaignStatus): string {
	switch(value) {
		case 0:
			return "Draft"
		case 10:
			return "Scheduled"
		case 20:
			return "Queuing"
		case 40:
			return "Sending"
		case 50:
			return "Paused"
		case 55:
			return "Suspended"
		case 60:
			return "Aborted"
		case 70:
			return "Sent"
		case 100:
			return "Error"
		default:
			return value?.toString()
	}
}

export enum DispatchCampaignType {
    EMAIL = 0,
    SMS = 1,
    PUSH = 2
}
export function friendlyEnumDispatchCampaignType(value: DispatchCampaignType): string {
	switch(value) {
		case 0:
			return "EMAIL"
		case 1:
			return "SMS"
		case 2:
			return "PUSH"
		default:
			return value?.toString()
	}
}

export enum DispatchCampaignProvider {
    SENDGRID_EMAIL = 'sendgrid_email',
    SIMULATION = 'simulation',
    SIMULATION_ALL_CUSTOMERS = 'simulation_all_customers',
    SIMULATION_INBOX_ENGAGEMENT = 'simulation_inbox_engagement',
    REDPOINT_PUSH = 'redpoint_push'
}
export function friendlyEnumDispatchCampaignProvider(value: DispatchCampaignProvider): string {
	switch(value) {
		case "sendgrid_email":
			return "Sendgrid Email"
		case "simulation":
			return "Simulation"
		case "simulation_all_customers":
			return "Simulation: All Customers"
		case "simulation_inbox_engagement":
			return "Simulation: Inbox + Engagement (Dev)"
		case "redpoint_push":
			return "Redpoint Push"
		default:
			return value?.toString()
	}
}

export enum DispatchCampaignSendingRateMode {
    FIXED_RATE = 'FIXED_RATE',
    RAMP_UP = 'RAMP_UP'
}
export function friendlyEnumDispatchCampaignSendingRateMode(value: DispatchCampaignSendingRateMode): string {
	switch(value) {
		case "FIXED_RATE":
			return "Fixed send rate per minute — best for those with an established sending reputation"
		case "RAMP_UP":
			return "Ramp up over specified number of days — recommended for those establishing a new sending reputation"
		default:
			return value?.toString()
	}
}

export enum BulkInvoicingStatus {
    DRAFT = 0,
    COMPLETED = 100,
    UNDONE = 200
}
export function friendlyEnumBulkInvoicingStatus(value: BulkInvoicingStatus): string {
	switch(value) {
		case 0:
			return "Draft"
		case 100:
			return "Completed"
		case 200:
			return "Undone"
		default:
			return value?.toString()
	}
}

export enum PrepaidFreezeUnit {
    DAYS = 'DAYS',
    WEEKS = 'WEEKS',
    MONTHS = 'MONTHS'
}
export function friendlyEnumPrepaidFreezeUnit(value: PrepaidFreezeUnit): string {
	switch(value) {
		case "DAYS":
			return "DAYS"
		case "WEEKS":
			return "WEEKS"
		case "MONTHS":
			return "MONTHS"
		default:
			return value?.toString()
	}
}

export enum PrepaidFreezeDayRestriction {
    ANY_DAY = 'ANY_DAY',
    FACILITY_BILLING_DAY = 'FACILITY_BILLING_DAY',
    MONTHLY_DAY = 'MONTHLY_DAY'
}
export function friendlyEnumPrepaidFreezeDayRestriction(value: PrepaidFreezeDayRestriction): string {
	switch(value) {
		case "ANY_DAY":
			return "ANY_DAY"
		case "FACILITY_BILLING_DAY":
			return "FACILITY_BILLING_DAY"
		case "MONTHLY_DAY":
			return "MONTHLY_DAY"
		default:
			return value?.toString()
	}
}

export enum NoticePeriodUnit {
    HOURS = 'HOURS',
    DAYS = 'DAYS',
    WEEKS = 'WEEKS',
    MONTHS = 'MONTHS'
}
export function friendlyEnumNoticePeriodUnit(value: NoticePeriodUnit): string {
	switch(value) {
		case "HOURS":
			return "HOURS"
		case "DAYS":
			return "DAYS"
		case "WEEKS":
			return "WEEKS"
		case "MONTHS":
			return "MONTHS"
		default:
			return value?.toString()
	}
}

export enum AssetScheduleCalendarMode {
    WHITELIST = 'WHITELIST',
    BLACKLIST = 'BLACKLIST',
    NONE = 'NONE'
}
export function friendlyEnumAssetScheduleCalendarMode(value: AssetScheduleCalendarMode): string {
	switch(value) {
		case "WHITELIST":
			return "WHITELIST"
		case "BLACKLIST":
			return "BLACKLIST"
		case "NONE":
			return "NONE"
		default:
			return value?.toString()
	}
}

export enum StorefrontType {
    WEB = 'WEB',
    KIOSK = 'KIOSK'
}
export function friendlyEnumStorefrontType(value: StorefrontType): string {
	switch(value) {
		case "WEB":
			return "WEB"
		case "KIOSK":
			return "KIOSK"
		default:
			return value?.toString()
	}
}

export enum GenerateEveryNthDayBidirectionalMode {
    START_DATE = 'START_DATE',
    FIXED_DATE = 'FIXED_DATE'
}
export function friendlyEnumGenerateEveryNthDayBidirectionalMode(value: GenerateEveryNthDayBidirectionalMode): string {
	switch(value) {
		case "START_DATE":
			return "START_DATE"
		case "FIXED_DATE":
			return "FIXED_DATE"
		default:
			return value?.toString()
	}
}

export enum LoyaltyDailyLimitScope {
    PROGRAM = 'program',
    FACILITY = 'facility'
}
export function friendlyEnumLoyaltyDailyLimitScope(value: LoyaltyDailyLimitScope): string {
	switch(value) {
		case "program":
			return "PROGRAM"
		case "facility":
			return "FACILITY"
		default:
			return value?.toString()
	}
}

export enum LoyaltyDailyEarningRuleMode {
    FIRST_MATCH = 'first_match',
    ALWAYS = 'always'
}
export function friendlyEnumLoyaltyDailyEarningRuleMode(value: LoyaltyDailyEarningRuleMode): string {
	switch(value) {
		case "first_match":
			return "First matching rule"
		case "always":
			return "Always award when matched"
		default:
			return value?.toString()
	}
}

export enum LoyaltyContractChargeType {
    CONTRACT_FEES = 'contract_fees',
    SCHEDULED_DUES = 'scheduled_dues',
    REQUIRED_TOKEN = 'required_token'
}
export function friendlyEnumLoyaltyContractChargeType(value: LoyaltyContractChargeType): string {
	switch(value) {
		case "contract_fees":
			return "CONTRACT_FEES"
		case "scheduled_dues":
			return "SCHEDULED_DUES"
		case "required_token":
			return "REQUIRED_TOKEN"
		default:
			return value?.toString()
	}
}

export enum LoyaltyEarningActionType {
    PURCHASE = 'purchase',
    CHECK_IN = 'check_in',
    CONTRACT_ACTIVATION = 'contract_activation',
    DAILY = 'daily'
}
export function friendlyEnumLoyaltyEarningActionType(value: LoyaltyEarningActionType): string {
	switch(value) {
		case "purchase":
			return "PURCHASE"
		case "check_in":
			return "CHECK_IN"
		case "contract_activation":
			return "CONTRACT_ACTIVATION"
		case "daily":
			return "DAILY"
		default:
			return value?.toString()
	}
}

export enum LoyaltyPointTransactionKind {
    AWARD = 10,
    REDEMPTION = 20,
    AWARD_REVERSAL = 30,
    REDEMPTION_RETURN = 40,
    MANUAL_ADJUSTMENT = 50,
    ELIGIBILITY_FORFEITURE = 60
}
export function friendlyEnumLoyaltyPointTransactionKind(value: LoyaltyPointTransactionKind): string {
	switch(value) {
		case 10:
			return "AWARD"
		case 20:
			return "REDEMPTION"
		case 30:
			return "AWARD_REVERSAL"
		case 40:
			return "REDEMPTION_RETURN"
		case 50:
			return "MANUAL_ADJUSTMENT"
		case 60:
			return "ELIGIBILITY_FORFEITURE"
		default:
			return value?.toString()
	}
}

export enum LoyaltyPurchaseLineItemScope {
    RETAIL = 'retail',
    CONTRACT = 'contract',
    BOTH = 'both'
}
export function friendlyEnumLoyaltyPurchaseLineItemScope(value: LoyaltyPurchaseLineItemScope): string {
	switch(value) {
		case "retail":
			return "Only retail line items"
		case "contract":
			return "Only contract line items"
		case "both":
			return "Both contract and retail line items"
		default:
			return value?.toString()
	}
}
